export default {"src":"/_next/static/media/Hamburger-Menu-Dark.53d9b74f.svg","height":24,"width":24};